export const initialState = {
  apiStatus: {
    loading: false,
    message: null,
    next: false,
    data: null,
    uploadPdf: [],
    apiError: false,
    apiSuccess: false,
  },
  preProProjects: [],
  type: "project",
  uploadedPdfAndTags: [],
  coorData: [],
  qcParametersData: [],
};
